<div class="social-links-wrapper" *transloco="let t;">
  <span class="store-name-label">{{ configState().store?.name }}</span>
  <div class="social-links-buttons-wrapper">
    @if (configState().socialLinks?.facebookPageId) {
      <a
          href="https://www.facebook.com/{{configState().socialLinks?.facebookPageId}}"
          target="_blank"
          class="primary-text-color social-link"
          id="facebook"
          [attr.aria-label]="t('footer.opens_in_a_new_tab_aria', {platform: 'Facebook' })"
      >
          <cwo-icon [name]="iconNameType.facebook" />
      </a>
    } 
    @if (configState().socialLinks?.twitterPageId) {
      <a
          href="https://www.twitter.com/{{configState().socialLinks?.twitterPageId}}"
          target="_blank"
          class="primary-text-color social-link"
          id="twitter"
          [attr.aria-label]="t('footer.opens_in_a_new_tab_aria', {platform: 'Twitter' })"
      >
          <cwo-icon [name]="iconNameType.twitter" />
      </a>
    } 
    @if(configState().socialLinks?.youtubePageId){
      <a
          href="https://www.youtube.com/{{configState().socialLinks?.youtubePageId}}"
          target="_blank"
          class="primary-text-color social-link"
          id="youtube"
          [attr.aria-label]="t('footer.opens_in_a_new_tab_aria', {platform: 'Youtube' })"
      >
          <cwo-icon [name]="iconNameType.youtube"/>
      </a>
    } 
    @if(configState().socialLinks?.instagramPageId){
      <a
          href="https://www.instagram.com/{{configState().socialLinks?.instagramPageId}}"
          target="_blank"
          class="primary-text-color social-link"
          id="instagram"
          [attr.aria-label]="t('footer.opens_in_a_new_tab_aria', {platform: 'Instagram'})"
      >
          <cwo-icon [name]="iconNameType.instagram" />
      </a>
    }
  </div>
</div>